import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-general-search-input',
  templateUrl: './general-search-input.component.html',
  styleUrls: ['./general-search-input.component.scss'],
})
export class GeneralSearchInputComponent {
  @Input() title!: string;
  @Input() expanded?: boolean;

  @ContentChild(TemplateRef) sortingContent!: TemplateRef<any>;
}
